import { render, staticRenderFns } from "./ChatMultimedia.vue?vue&type=template&id=47c3fd5d&scoped=true&"
import script from "./ChatMultimedia.vue?vue&type=script&lang=js&"
export * from "./ChatMultimedia.vue?vue&type=script&lang=js&"
import style0 from "./ChatMultimedia.vue?vue&type=style&index=0&id=47c3fd5d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3fd5d",
  null
  
)

export default component.exports